<div class="modal-content">
  <div class="modal-header">
    <h4 style="max-width: 80%"><strong> {{ heading }} </strong></h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clicked(false)">
      <fa-icon [icon]="['far', 'times-circle']" size="lg">  </fa-icon>
    </button>
  </div>
  <div class="modal-body our-form-background">
    <div *ngFor="let section of helpInfo?.sections; let last = last;">
      <div class="row" *ngIf="section?.heading && helpInfo?.sections?.length > 1">
        <div class="col">
          <h6><strong>{{section.heading}}</strong></h6>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div *ngIf="section?.body" [innerHTML]="section?.body"></div>
        </div>
      </div>
      <div class="row" *ngIf="helpInfo?.sections?.length > 1 && !helpInfo === last">
        <div class="col-12">
          <p-divider></p-divider>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <div>
      <button type="button" pButton class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + noButtonColour" (click)="clicked(false)" >
        <span>{{ noButtonText }}</span> <fa-icon style="margin-left: 10px" [icon]="['far', 'times']" size="lg" ></fa-icon>
      </button>
    </div>
  </div>
</div>
